/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { change_requests_ParentChangeRequestExecutorDTO } from './change_requests_ParentChangeRequestExecutorDTO';
import type { change_requests_ParentChangeRequestResolutionDTO } from './change_requests_ParentChangeRequestResolutionDTO';
export type change_requests_ParentChangeRequestInputDTO = {
    executor?: change_requests_ParentChangeRequestExecutorDTO;
    family: change_requests_ParentChangeRequestInputDTO.family;
    resolved?: change_requests_ParentChangeRequestResolutionDTO;
    sub_type?: string;
};
export namespace change_requests_ParentChangeRequestInputDTO {
    export enum family {
        CONTACT_DATA = 'contact_data',
        CHILDREN = 'children',
        CONTRACT = 'contract',
        GROUP_ALLOCATION = 'group_allocation',
        CHILD_CONTACT = 'child_contact',
    }
}

